var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAesoItcOutageError = function SvgAesoItcOutageError(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "16px",
    viewBox: "0 0 17 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1-outage-error-1",
    points: "0 0.358536585 16.0013082 0.358536585 16.0013082 15 0 15"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "outage-error-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "real-time_graphical",
    transform: "translate(-870.000000, -1801.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "map-comp-outage-error-1",
    transform: "translate(212.000000, 1578.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6-outage-error-1",
    transform: "translate(658.246746, 223.529427)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-outage-error-1"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2-outage-error-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.78730667,1.07930488 L0.189617778,12.8374756 C-0.349404444,13.7985732 0.324728889,15.0000366 1.40312889,15.0000366 L14.5981511,15.0000366 C15.6765511,15.0000366 16.35104,13.7985732 15.8113067,12.8374756 L9.21432889,1.07930488 C8.67459556,0.118207317 7.32668444,0.118207317 6.78730667,1.07930488",
    id: "Fill-1-outage-error-1",
    fill: "#D31C16",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.94482743,9.8768021 L7.812345,9.8768021 L7.65217391,5.25 L9.10499852,5.25 L8.94482743,9.8768021 Z M8.37876823,10.6011664 C8.60810411,10.6011664 8.79302892,10.6669856 8.93317862,10.79827 C9.07332833,10.9299083 9.14285714,11.0983486 9.14285714,11.3028834 C9.14285714,11.5045872 9.07332833,11.6712582 8.93317862,11.8025426 C8.79302892,11.9341809 8.60810411,12 8.37876823,12 C8.15234455,12 7.96887584,11.9341809 7.82909016,11.8025426 C7.68894046,11.6712582 7.61904762,11.5045872 7.61904762,11.3028834 C7.61904762,11.1011796 7.68894046,10.9338008 7.82909016,10.8007471 C7.96887584,10.6676933 8.15234455,10.6011664 8.37876823,10.6011664 L8.37876823,10.6011664 Z",
    id: "Fill-4-outage-error-1",
    fill: "#FEFEFE"
  })))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAesoItcOutageError);
export default ForwardRef;